import React from 'react';
import { MoonIcon, SparklesIcon, ZapIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-taupe text-cream relative overflow-hidden" data-id="element-157">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-158"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-olive/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-159"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-160">
        <div className="text-center mb-16" data-id="element-161">
          <span className="inline-block px-4 py-1 rounded-full border border-gold/30 text-gold text-sm font-body tracking-widest uppercase mb-6" data-id="element-162">
            El Secreto
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-163">
            La solución no es comer menos, sino activar el{' '}
            <span className="text-gold" data-id="element-164">
              Protocolo "Anti-Cortisol" Nocturno
            </span>
            .
          </h2>
        </div>

        <div className="bg-cream/5 border border-cream/10 rounded-3xl p-8 md:p-12 backdrop-blur-sm" data-id="element-165">
          <p className="text-xl font-body leading-relaxed mb-8 text-cream/90" data-id="element-166">
            Este sistema diseñado específicamente para mujeres post-menopausia
            no se enfoca en lo que haces durante el día, sino en{' '}
            <strong className="text-gold font-normal" data-id="element-167">
              cómo preparas a tu cuerpo para la noche
            </strong>
            .
          </p>

          <div className="flex flex-col md:flex-row items-center gap-8 bg-black/20 rounded-2xl p-6 md:p-8" data-id="element-168">
            <div className="flex-shrink-0 bg-gold/20 p-4 rounded-full" data-id="element-169">
              <MoonIcon className="w-12 h-12 text-gold" data-id="element-170" />
            </div>
            <p className="text-lg font-body leading-relaxed text-cream/80" data-id="element-171">
              Al calmar el sistema nervioso antes de dormir, permites que tu{' '}
              <strong className="text-white" data-id="element-172">
                metabolismo silver se "reinicie"
              </strong>
              , usando las reservas acumuladas en el abdomen como combustible
              natural mientras descansas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}